/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import Text from 'src/components/ts-components/Text'
import CopyComponent from 'src/components/CopyComponent'

interface PlayerInfoSectionProps {
  playerId?: string
  registrationId?: string
  scheduleId: string
  disableFields?: boolean
}

/**
 * 🔄 PlayerInfoSection: Displays player information header with ID copying functionality
 *
 * This component shows the player info section with copy functionality for Player ID
 * and Registration ID, plus sharing functionality for registration.
 */
const PlayerInfoSection = ({
  playerId,
  registrationId,
  scheduleId,
  disableFields = false,
}: PlayerInfoSectionProps) => {
  console.log('🔄 PlayerInfoSection: Rendering player info section', {
    playerId,
    registrationId,
    scheduleId,
    disableFields,
  })

  return (
    <div
      css={css`
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        gap: 16px;
        width: 100%;
      `}
    >
      <Text
        variant='captionLarge'
        weight='semiBold'
        color={colors.NEUTRAL_0}
        style={`
          align-self: center;
        `}
      >
        Player Info
      </Text>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: flex-end;
          gap: 8px;
        `}
      >
        {playerId ? (
          <CopyComponent
            customText='Player ID'
            id={playerId || ''}
            alternativeBackground={disableFields}
          />
        ) : null}
        {registrationId ? (
          <>
            <CopyComponent
              customText='Registration ID'
              id={registrationId || ''}
              alternativeBackground={disableFields}
            />
          </>
        ) : null}
      </div>
    </div>
  )
}

export default PlayerInfoSection
